"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderVariantById = void 0;
const getOrderVariantById = async (supabase, id) => {
    const { data, error } = await supabase
        .from("order_variants")
        .select(`*,
          order_lines!id(*,         
            reminders(*),
            versions:order_line_versions!order_line_id(
              *,
              regions(id, name, slug, country_id),
              order_lines!linked_line_id(*, 
                versions:order_line_versions!order_line_id
                (*)
              )
            )
          )
        `)
        .eq("id", id)
        .single();
    if (error) {
        throw new Error(error.message);
    }
    return data;
};
exports.getOrderVariantById = getOrderVariantById;
